<template>
  <div id="map-out" ref="mapOut">
    <div id="allmap" ref="allMap" class="dark-map" />
  </div>
</template>

<script>
let isFirst = true
let isRefresh = false
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import mapUtil from '../business/map/MapUtils'
import { mapMutations, mapState } from 'vuex'
import convertUtil from '../business/map/ConvertPointUtil'

let isCommercialProp

export default {
  name: 'MapView',
  props: ['points', 'areasData', 'isCommercial'],

  created() {
    isCommercialProp = this.isCommercial
    this.markIconWidth = this.fontSize(0.3)
    this.markIconHeight = this.fontSize(0.4)
  },
  mounted() {
    if (this.interval) {
      clearInterval(this.interval)
    }
    this.changeOffset()
    window.addEventListener('resize', this.changeOffset)
    this.usePoints = JSON.parse(JSON.stringify(this.points))
    this.convertPoints(this.usePoints, this.initLeafletMap)
  },
  computed: {
    ...mapState({
      mapRefresh: (state) => state.setting.mapRefresh
    })
  },
  data() {
    return {
      markIconWidth: 35,
      markIconHeight: 45,
      map: null,
      markers: [],
      locationMarker: '',
      usePoints: [],
      offset: {},
      menuCollNum: 0,
      centerMark: null,
      eventclick: false,
      enentlng: 0,
      eventlat: 0,
      TIANDITU_KEY: 'ac43c005cc12956e7f95529cd70cc405'
    }
  },
  watch: {
    points() {
      isRefresh = true
      this.usePoints = JSON.parse(JSON.stringify(this.points))
      this.convertPoints(this.usePoints, this.initLeafletMap)
    },
    areasData(val) {
      if (val) {
        this.updateIcon(val)
      }
    }
  },
  methods: {
    ...mapMutations({
      setMapRefresh: 'setting/setMapRefresh'
    }),

    initLeafletMap() {
      if (!this.map) {
        this.map = L.map('allmap', {
          zoomControl: false,
          attributionControl: false
        })

        const mapContainer = this.$refs.allMap
        if (mapContainer) {
          const leafletControlPane = mapContainer.querySelector('.leaflet-control-container')
          if (leafletControlPane) {
            leafletControlPane.style.zIndex = '10'
          }
          const leafletPane = mapContainer.querySelector('.leaflet-pane')
          if (leafletPane) {
            leafletPane.style.zIndex = '1'
          }
        }

        const tiandituKey = this.TIANDITU_KEY

        const vecLayer = L.tileLayer(
          'http://t{s}.tianditu.gov.cn/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=' + tiandituKey,
          {
            subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
            maxZoom: 18
          }
        )

        const cvaLayer = L.tileLayer(
          'http://t{s}.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=' + tiandituKey,
          {
            subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
            maxZoom: 18
          }
        )

        this.map.addLayer(vecLayer)
        this.map.addLayer(cvaLayer)

        L.control.scale({ imperial: false }).addTo(this.map)

        if (!this.usePoints.length && isFirst) {
          let cityInfo = mapUtil.getDefaultCityPoint()
          const wgs84Coords = convertUtil.bd09towgs84(
            parseFloat(cityInfo.lng),
            parseFloat(cityInfo.lat)
          )
          this.map.setView([wgs84Coords[1], wgs84Coords[0]], 15)
        }
      } else {
        this.markers.forEach(marker => {
          this.map.removeLayer(marker)
        })
        this.markers = []
      }

      if (this.eventclick) {
        const wgs84Coords = convertUtil.bd09towgs84(this.enentlng, this.eventlat)
        this.map.setView([wgs84Coords[1], wgs84Coords[0]], 18)
      }

      if (this.usePoints && this.usePoints.length) {
        for (let i = 0; i < this.usePoints.length; i++) {
          this.addMarker(this.map, this.usePoints[i])
        }
        if (isFirst || this.mapRefresh) {
          this.setMapRefresh(false)
          isFirst = false
        }
      }

      this.setZoom(this.map, this.usePoints)
      isRefresh = false
    },

    addMarker(map, wgsPoint) {
      if (!wgsPoint.hasOwnProperty('wgs84Point')) return

      const icon = this.mapIcon(
        wgsPoint.alarmNum,
        wgsPoint.breakDownNum,
        wgsPoint.normalNum,
        wgsPoint.outlineNum,
        wgsPoint.expire,
        this.markIconWidth,
        this.markIconHeight
      )

      const leafletIcon = L.icon({
        iconUrl: icon.iconUrl,
        iconSize: [this.markIconWidth, this.markIconHeight],
        iconAnchor: [this.markIconWidth / 2, this.markIconHeight / 2]
      })

      const marker = L.marker(
        [wgsPoint.wgs84Point[1], wgsPoint.wgs84Point[0]],
        { icon: leafletIcon }
      )

      marker.wgsPoint = wgsPoint
      marker.addTo(map)
      this.markers.push(marker)

      // 添加文字标注
      const iconImageSize = 50
      const nameLabel = L.divIcon({
        className: 'custom-map-label',
        html: `<div style="color: #FFD700; font-size: 12px; font-weight: bold; white-space: nowrap; text-align:center;">${wgsPoint.areaName}</div>`,
        iconSize: [iconImageSize, iconImageSize],
        iconAnchor: [iconImageSize/2, -iconImageSize/3]
      })
      const labelMarker = L.marker(
        [wgsPoint.wgs84Point[1], wgsPoint.wgs84Point[0]],
        { 
          icon: nameLabel,
          interactive: false  // 让文字标注不拦截鼠标事件
        }
      )
      labelMarker.addTo(map)

      marker.on('click', (e) => {
        this.clearAnimation()
        this.centerMark = marker
        this.map.setView([wgsPoint.wgs84Point[1], wgsPoint.wgs84Point[0]], this.map.getZoom())
        this.startBouncing(marker)
        this.$emit('resultPoint', wgsPoint)
      })

      marker.on('mouseover', (e) => {
        const mouseoverObj = {
          x: e.originalEvent.clientX,
          y: e.originalEvent.clientY,
          data: wgsPoint
        }
        this.$emit('mapMouseover', mouseoverObj)
      })

      marker.on('mouseout', () => {
        this.$emit('mapMouseout')
      })
    },

    mapIcon(alarmNum, breakDownNum, normalNum, outlineNum, expire, width, height) {
      const alarmIcon = { iconUrl: require('@/assets/imgs/u188.png') }
      const breakDownIcon = { iconUrl: require('@/assets/imgs/u193.png') }
      const outLineIcon = { iconUrl: require('@/assets/imgs/u218.png') }
      const normalIcon = { iconUrl: require('@/assets/imgs/u183.png') }
      const householdNormalIcon = { iconUrl: require('@/assets/imgs/u1607.png') }
      const householdBreakDownIcon = { iconUrl: require('@/assets/imgs/u1605.png') }

      if (alarmNum > 0) {
        return alarmIcon
      } else if (alarmNum <= 0 && breakDownNum > 0) {
        return isCommercialProp == 0 ? breakDownIcon : householdBreakDownIcon
      } else if (
        alarmNum <= 0 &&
        breakDownNum <= 0 &&
        expire > 0 &&
        isCommercialProp !== 0
      ) {
        return breakDownIcon
      } else if (
        normalNum === 0 &&
        alarmNum === 0 &&
        breakDownNum === 0 &&
        expire === 0 &&
        outlineNum >= 0
      ) {
        return outLineIcon
      } else {
        return isCommercialProp == 0 ? normalIcon : householdNormalIcon
      }
    },

    updateIcon(areasData) {
      const mapPointdata = areasData
      for (let i = 0; i < this.markers.length; i++) {
        for (let j = 0; j < mapPointdata.length; j++) {
          if (this.markers[i].wgsPoint.areaId == mapPointdata[j].areaId) {
            this.markers[i].wgsPoint.alarmNum = mapPointdata[j].alarmNum
            this.markers[i].wgsPoint.normalNum = mapPointdata[j].normalNum
            this.markers[i].wgsPoint.outlineNum = mapPointdata[j].outlineNum
            this.markers[i].wgsPoint.breakDownNum = mapPointdata[j].breakDownNum
            this.markers[i].wgsPoint.expire = mapPointdata[j].expire

            const icon = this.mapIcon(
              mapPointdata[j].alarmNum,
              mapPointdata[j].breakDownNum,
              mapPointdata[j].normalNum,
              mapPointdata[j].outlineNum,
              mapPointdata[j].expire,
              this.markIconWidth,
              this.markIconHeight
            )

            const leafletIcon = L.icon({
              iconUrl: icon.iconUrl,
              iconSize: [this.markIconWidth, this.markIconHeight],
              iconAnchor: [this.markIconWidth / 2, this.markIconHeight / 2]
            })

            this.markers[i].setIcon(leafletIcon)
          }
        }
      }
    },

    setZoom(map, wgsPoints) {
      const validPoints = []
      wgsPoints.forEach((item) => {
        if (item.wgs84Point) {
          validPoints.push([item.wgs84Point[1], item.wgs84Point[0]])
        }
      })

      if (validPoints.length) {
        const bounds = L.latLngBounds(validPoints)
        map.fitBounds(bounds, { padding: [50, 50] })
      }
    },

    handlePoint(points) {
      const wgs84Points = []
      points.forEach((element) => {
        if (element.lat > 0 && element.lng > 0) {
          if (convertUtil.COOR_TYPE_WGS84 == element.coorType) {
            this.$set(element, 'wgs84Point', [element.lng, element.lat])
            wgs84Points.push(element)
          } else if (convertUtil.COOR_TYPE_BD09LL == element.coorType) {
            const wgs84 = convertUtil.bd09towgs84(element.lng, element.lat)
            this.$set(element, 'wgs84Point', wgs84)
            wgs84Points.push(element)
          }
        }
      })
      return wgs84Points
    },

    async convertPoints(wgsPoints, callback) {
      if (wgsPoints.length) {
        this.handlePoint(wgsPoints)
      }
      callback()
    },

    changeOffset() {
      if (!this.$refs.allMap || !this.$refs.mapOut) return
    },

    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth
      if (!clientWidth) return
      let fontSize = 100 * (clientWidth / 1920)
      return res * fontSize
    },

    moveToPoint(point) {
      if (point) {
        const lat = point.latitude || point.lat
        const lng = point.longitude || point.lng
        let wgs84Coords

        if (point.coorType === convertUtil.COOR_TYPE_BD09LL) {
          wgs84Coords = convertUtil.bd09towgs84(lng, lat)
        } else {
          wgs84Coords = [lng, lat]
        }

        for (let j = 0; j < this.markers.length; j++) {
          const mapobj = this.markers[j]
          if (
            Math.abs(mapobj.wgsPoint.lat - lat) < 0.0001 &&
            Math.abs(mapobj.wgsPoint.lng - lng) < 0.0001
          ) {
            this.clearAnimation()
            this.centerMark = mapobj
            this.map.setView([wgs84Coords[1], wgs84Coords[0]], this.map.getZoom())
            this.startBouncing(mapobj)
          }
        }
      }
    },

    startBouncing (marker) {
      if (!marker) return
      
      this.stopBouncing()
      marker.isBouncing = true
      
      let bounceCount = 0
      const maxBounces = 10
      const originalLatLng = marker.getLatLng()
      const bounceHeight = 0.0002
      
      this.animationInterval = setInterval(() => {
        if (!marker.isBouncing || bounceCount >= maxBounces) {
          this.stopBouncing()
          marker.setLatLng(originalLatLng)
          return
        }
        
        bounceCount++
        const progress = bounceCount / maxBounces
        const height = bounceHeight * Math.sin(progress * Math.PI) * (1 - progress * 0.5)
        
        marker.setLatLng([originalLatLng.lat + height, originalLatLng.lng])
      }, 50)
    },

    stopBouncing () {
      if (this.animationInterval) {
        clearInterval(this.animationInterval)
        this.animationInterval = null
      }
      
      this.markers.forEach(marker => {
        marker.isBouncing = false
      })
    },

    clearAnimation () {
      this.stopBouncing()
      this.centerMark = null
    }
  }
}
</script>

<style lang="less" scoped>
.map-out {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 0;
}
#allmap {
  // border: 1px solid #eee;
  width: 100%;
  height: 100%;
  right: 0;
  top: 0;
  position: absolute;
  overflow: hidden;
  font-family: '微软雅黑';
  z-index: 0;
}

// 暗色地图滤镜样式 - 只在当前组件内生效
/deep/ #allmap.dark-map .leaflet-tile-container img {
  filter: invert(1) hue-rotate(180deg) brightness(0.9) contrast(1.1) !important;
}

/deep/ #allmap.dark-map .leaflet-marker-pane img {
  filter: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/bigscreen/MapComponent.vue